import { useQuery } from "@tanstack/react-query";
import TutorialJourneyProfilesService from "../../../services/TutorialJourneyProfilesService";

export const TUTORIAL_JOURNEY_PROFILES_EDITOR_KEY =
  "tutorial-journey-profiles-editor";

export function useTutorialJourneyProfiles() {
  return useQuery({
    queryKey: [TUTORIAL_JOURNEY_PROFILES_EDITOR_KEY],
    queryFn: () => TutorialJourneyProfilesService.getTutorialJourneysProfiles(),
    refetchOnMount: "always",
  });
}
